export const getSuiteName = (value: string) => {
  if (/^suite_/i.test(value || "")) {
    return String(value).replace(/^suite_/i, "");
  }

  return "";
};

export const createSuiteName = (value: string) => {
  const display = getSuiteName(value) || String(value || "").trim();
  if (!display) {
    return "";
  }
  return `SUITE_${display}`;
};

export const prepareSectionRowSeat = (
  section: string,
  row: string,
  seat: string,
  suite: string,
  show: boolean,
) => {
  if (suite && show) {
    return {
      section: createSuiteName(suite),
      row: "SUITE",
      seat: "SUITE",
    };
  }

  return {
    section,
    row,
    seat,
  };
};

type SuiteSection = {
  name?: string;
  rows?: string[];
  seats?: { [row: string]: string[] };
};

/** Pick a real indexed seat in the suite so camera lookup matches mapped row/seat numbers. */
export const resolveSuiteMappedPlace = (
  suiteDisplayOrName: string,
  allSuites: SuiteSection[] = [],
): { section: string; row: string; seat: string } => {
  const display = getSuiteName(suiteDisplayOrName) || String(suiteDisplayOrName || "").trim();
  const sectionName = createSuiteName(display);
  const suiteSection = (allSuites || []).find((item) => {
    const name = item.name || "";
    return name.toLowerCase() === sectionName.toLowerCase()
      || getSuiteName(name) === display;
  });
  const seatsMap = suiteSection?.seats || {};
  const rows = suiteSection?.rows || Object.keys(seatsMap);
  const row = rows.find((r) => (seatsMap[r] || []).length > 0)
    || Object.keys(seatsMap).find((r) => (seatsMap[r] || []).length > 0);
  const mappedSeat = row ? (seatsMap[row] || [])[0] : undefined;
  return {
    section: suiteSection?.name || sectionName,
    row: row || "SUITE",
    seat: mappedSeat || "SUITE",
  };
};
